import { render, staticRenderFns } from "./MandateConformityBanner.vue?vue&type=template&id=4c482a4a&scoped=true&"
import script from "./MandateConformityBanner.vue?vue&type=script&lang=js&"
export * from "./MandateConformityBanner.vue?vue&type=script&lang=js&"
import style0 from "./MandateConformityBanner.vue?vue&type=style&index=0&id=4c482a4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c482a4a",
  null
  
)

export default component.exports